import React from "react";
import "./Navbar.css";

function Navbar() {
  const handleScrollToPalmFeatures = () => {
    const section = document.getElementById("palm-features");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <nav
      className="navbar"
      style={{
        backgroundImage: "url('/background.png')",
        backgroundSize: "auto",
        backgroundPosition: "bottom center",
        backgroundRepeat: "repeat",
      }}
    >
      <div className="navbar-left">
        <ul>
          <li><a href="#home" className="nav-link">Home</a></li>
          <li><a href="#features" className="nav-link">Features</a></li>
          <li>
            <a
              href="#palm-features"
              className="nav-link"
              onClick={(e) => {
                e.preventDefault();
                handleScrollToPalmFeatures();
              }}
            >
              Solutions
            </a>
          </li>
        </ul>
      </div>
      <div className="navbar-center">SWAYAMYOU</div>
      <div className="navbar-right">
        <button className="Sign" onClick={handleScrollToPalmFeatures}>
          Book Demo
        </button>
      </div>
    </nav>
  );
}

export default Navbar;
